import type { CoinType } from '../cointype/CoinTypeStore';
import type { GameLabel } from '../game/types';
import type { BundleItem } from '../rewards/types';

export enum MissionTypeEnum {
  SPIN_X_TIMES = 'SPIN_X_TIMES',
  BET_SUM_OF = 'BET_SUM_OF',
  WIN_SUM_OF = 'WIN_SUM_OF',
}

// Mission types whose progress is displayed as an integer (not decimal)
export const MissionsWithIntegerProgress: MissionTypeEnum[] = [
  MissionTypeEnum.SPIN_X_TIMES,
  MissionTypeEnum.WIN_SUM_OF,
  MissionTypeEnum.BET_SUM_OF,
];

export type MissionStatus = 'active' | 'completed' | 'claimed' | 'upcoming';

export interface MissionPackageData {
  packageId: number;
  scCoin: number;
  gcCoin: number;
  amount: number;
  bundleItems: BundleItem[];
}

export interface MissionGame {
  gameId: number | null;
  gameName: string;
  gameImageUrl: string;
  providerId: number | null;
}

export interface MissionResponse {
  id: string;
  missionVersionId: string;
  missionType: MissionTypeEnum;
  goal: number;
  progress: number;
  status: MissionStatus;
  coinType: CoinType;
  order: number;
  streakPoints: number;
  timeLeft: number;
  startedAt: string | null; // ISO 8601
  completedAt: string | null; // ISO 8601
  claimedAt: string | null; // ISO 8601
  isFallback: boolean;
  packageData: MissionPackageData | null;
  game: MissionGame;
}

export interface UnclaimedReward {
  id: string;
  missionVersionId: string;
  missionType: MissionTypeEnum;
  coinType: CoinType;
  completedAt: string; // ISO 8601
  packageData: MissionPackageData;
  game: MissionGame;
  isFallback: boolean;
}

export interface StreakMilestone {
  id: string;
  requiredPoints: number;
  coinType: CoinType;
  order: number;
  claimed: boolean;
  packageData: MissionPackageData;
  isFallback: boolean;
}

export interface StreakInfo {
  totalPoints: number;
  lastClaimedOrder: number;
  milestones: StreakMilestone[];
}

export interface MissionResetTime {
  resetTime: string;
  countryCode: string;
  territoryKey: string;
}

export interface MissionSetResponse {
  missions: MissionResponse[];
  unclaimedRewards: UnclaimedReward[];
  streak: StreakInfo | null;
  resetTime: MissionResetTime | null;
  expiresAt: string | null; // ISO 8601
}

export interface ClaimedReward {
  id: string;
  missionVersionId: string;
  packageData: MissionPackageData | null;
  isFallback: boolean;
}

export interface GetUserMissionsResponse {
  scMissions: MissionSetResponse;
  gcMissions: MissionSetResponse;
  isOnboarding: boolean;
  onboardingMissions: MissionSetResponse | null;
  gameLabel: GameLabel | null;
}
